import { MaybeRef, unref } from 'vue'

const encoder = new TextEncoder()
const decoder = new TextDecoder()

function base64ToBytes(base64: string) {
  const binString = atob(base64)
  return Uint8Array.from(binString, (m) => m.codePointAt(0) ?? 0)
}

function bytesToBase64(bytes: Uint8Array) {
  const binString = Array.from(bytes, (byte) => String.fromCodePoint(byte)).join('')
  return btoa(binString)
}

export const btoaSafe = (str: string): string => bytesToBase64(encoder.encode(str))
export const atobSafe = (str: string): string => decoder.decode(base64ToBytes(str))

export const countActiveFilters = (values: any[]): number =>
  values
    .filter((value) => value !== undefined && value !== null)
    .map((val) => {
      if (val instanceof Array) {
        return Number(val.length > 0)
      }
      if (val instanceof Object) {
        return Object.values(val).some((v) => v !== undefined && v !== null) ? 1 : 0
      }
      return 1
    })
    .reduce((a, b) => a + b, 0)

export const resetFilters = (
  filterValues: MaybeRef<Record<string, any>>,
  filters: string[] = [],
) => {
  const values = unref(filterValues)
  const keys = filters.length > 0 ? filters : Object.keys(values)
  for (const key of keys) {
    if (key in values) {
      if (values[key] instanceof Array) {
        values[key] = []
      } else if (typeof values[key] === 'object') {
        for (const subKey in values[key]) {
          if (subKey in values[key]) {
            values[key][subKey] = null
          }
        }
      } else {
        values[key] = undefined
      }
    }
  }
}
